import {h} from "../_snowpack/pkg/preact.js";
import {useState} from "../_snowpack/pkg/preact/hooks.js";
export default function TextInput({value, onChange, type, label, placeholder, style}) {
  const [inputID] = useState(`input-id-${Math.floor(Math.random() * 1e4)}`);
  return /* @__PURE__ */ h("div", {
    class: `w-full ${style ?? ""}`
  }, /* @__PURE__ */ h("label", {
    class: "text-gray-500 italic",
    for: inputID
  }, label), /* @__PURE__ */ h("input", {
    class: "w-full p-2 text-md rounded-md bg-gray-200 dark:bg-gray-600 text-black dark:text-white",
    id: inputID,
    type: type ?? "text",
    value,
    onInput: (e) => typeof onChange === "function" && onChange(e.target.value),
    placeholder
  }));
}
